
export enum PaymentSlipStatus {
    WaitingApproval,
    ApprovedByGAC,
    RejectedByGAC
}
